import { useState } from 'react';
import { LinearProgress, Tabs } from '../../tailwindcomponents';
import LiteHandover from '../Lite/LiteHandover';
import { useSelector } from 'react-redux'
import { RootState } from '../../reducer';
import FlightScheduleView from "../Line/FlightSchedule";
import { useQueryTab } from '../../utils/usePersistedTab';
import WorkPackageCalendar from '../Line/WorkPackageCalendar';
import { IssueHistory } from '../../components/Handover';

function ReykjavikLineSupervisor() {
    const { tabValue, setTabValue } = useQueryTab("tab", 0);
    const dashTails = ["TF-FXG", "TF-FXI", "TF-FXK", "TF-FXA", "TF-FXH", "TF-FXE"];
    const [loading, setLoading] = useState<boolean>(true);

    const store = useSelector((state: RootState) => state);
    const groups = store.user.me.user_clearence_groups;
    const isAdmin = groups.includes("Rvk Line Edit") || groups.includes("Rvk Line View");
    
    return (
        <div>
            {loading && <LinearProgress />}
            <Tabs
                tabNames={["Calendar", "Flight Schedule", "Handover", "Issue History"]}
                onChangeTabValue={(tabValue: number) => setTabValue(tabValue)}
                tabValue={tabValue}
            />
            {tabValue === 0 && <WorkPackageCalendar setLoading={setLoading} isAdmin={isAdmin} accessGroups={groups} location="RKV" />}
            {tabValue === 1 && <FlightScheduleView setLoading={setLoading} isLineSupervisorAdmin={isAdmin} />}
            {tabValue === 2 && <LiteHandover setLoading={setLoading} workPlace='RVK' allTails={dashTails} />}
            {tabValue === 3 && <IssueHistory setLoading={setLoading} />}
        </div>
    );
};
export default ReykjavikLineSupervisor;